import { versions } from "@/mocks/versions";
import SectionHeading from "./SectionHeading";

export default function UncutSection() {
  return (
    <section id="uncut" className="w-full bg-background-50 py-16 md:py-24 scroll-mt-24">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-start">
          <div className="lg:sticky lg:top-28">
            <SectionHeading
              eyebrow="Uncut & versions"
              title="未删减与原版：为什么同一部片会有好几个版本"
            />
            <p className="mt-6 text-sm md:text-base leading-relaxed text-foreground-700">
              搜索「未删减」时，你真正想确认的往往是：自己看到的这一版，是不是创作者原本想要的版本。
              答案取决于它是院线版、导演剪辑版、延长版，还是某个地区的删减版。理解差异，比记住片名更重要。
            </p>

            <div className="mt-8 w-full aspect-[16/10] rounded-lg overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20still%20of%20vintage%20film%20reels%20and%20an%20editing%20bench%20in%20a%20dim%20warm%20room%2C%20scattered%20film%20strips%2C%20moody%20editorial%20atmosphere%2C%20muted%20amber%20and%20brown%20palette%2C%20soft%20film%20grain&width=1200&height=750&seq=uncut-film-reels&orientation=landscape"
                alt="电影胶片与剪辑台，象征不同剪辑版本之间的差异"
                className="w-full h-full object-cover object-top"
              />
            </div>

            <div className="mt-6 flex items-start gap-3 rounded-lg bg-accent-50 border border-accent-200 p-4">
              <i className="ri-information-line text-accent-700 text-lg mt-0.5"></i>
              <p className="text-xs md:text-sm leading-relaxed text-foreground-700">
                小提示：同一部影片在不同播放源可能标注为不同版本，留意片尾时长，通常能快速判断自己看的是哪一版。
              </p>
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {versions.map((v, i) => (
              <div
                key={v.id}
                className="flex flex-col rounded-lg border border-background-200/70 bg-background-100 p-5 md:p-6"
              >
                <div className="flex items-center justify-between">
                  <span className="font-label text-xs tracking-[0.2em] text-foreground-400">
                    0{i + 1}
                  </span>
                  <i className="ri-file-list-3-line text-xl text-primary-600"></i>
                </div>
                <h3 className="mt-4 font-heading text-lg font-semibold text-foreground-950">{v.type}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-700">{v.desc}</p>
                <p className="mt-3 pt-3 border-t border-background-200/70 text-xs leading-relaxed text-accent-700">
                  {v.diff}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}